"use strict";
// packages/contracts/src/fila.ts — Fase 03, Plano 05 (OPS-04, D-02).
// Contratos para Fila de Produção e Reordenação Manual do Planejamento.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fila.js.map